<script setup>
  import { ref, computed } from "vue";
  import { storeToRefs } from "pinia";
  import { Input } from "@/components/ui/input";
  import { Search } from "lucide-vue-next";
  import ListContainer from "@/components/episto-ui/list/ListContainer.vue";
  import ListItem from "@/components/episto-ui/list/ListItem.vue";
  import AddLanguageDialog from "@/components/Admin/DefaultMessages/AddLanguageDialog.vue";
  import { useDefaultMessagesStore } from "@stores/survey/defaultMessages";

  const store = useDefaultMessagesStore();
  const { allMessages } = storeToRefs(store);
  const { selectLanguage, deleteMessage, isLanguageSelected } = store;

  const showAddDialog = ref(false);
  const search = ref("");

  const getLanguageLabel = (dm) => `${dm.name} (${dm.language})`;

  const filteredMessages = computed(() => {
    if (!search.value) return allMessages.value;
    const query = search.value.toLowerCase();
    return allMessages.value.filter((dm) => dm.name.toLowerCase().includes(query));
  });
</script>

<template>
  <ListContainer
    :add-element="() => (showAddDialog = true)"
    element-name="language">
    <template #header-action>
      <Input
        v-model="search"
        :icon="Search"
        placeholder="Search language..."
        clearable />
    </template>
    <template #elements>
      <ListItem
        v-for="(dm, index) in filteredMessages"
        :key="dm.language"
        :index="index"
        :element-title="getLanguageLabel(dm)"
        :select-element="() => selectLanguage(dm.language)"
        :delete-element="dm.language === 'en' ? null : () => deleteMessage(dm.language)"
        :confirm-deletion="true"
        :is-element-selected="() => isLanguageSelected(dm.language)" />
    </template>
  </ListContainer>

  <AddLanguageDialog
    :open="showAddDialog"
    @update:open="showAddDialog = $event" />
</template>
